"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalActions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var buttons_1 = require("../buttons");
var ModalActions = function (_a) {
    var onConfirm = _a.onConfirm, onCancel = _a.onCancel, titles = _a.titles, _b = _a.confirmButtonProps, confirmButtonProps = _b === void 0 ? {} : _b, _c = _a.cancelButtonProps, cancelButtonProps = _c === void 0 ? {} : _c, dataTestID = _a["data-testid"];
    var buttonClasses = (0, classnames_1.default)(' squid-flex-grow ', ' md:squid-basis-0 ', ' squid-basis-full ');
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: 'squid-mt-core-space-sm squid-flex squid-flex-wrap squid-gap-core-space-sm' }, { children: [onCancel ? ((0, jsx_runtime_1.jsx)(buttons_1.Button, __assign({ className: buttonClasses, onClick: onCancel, variant: "outlined", "data-testid": "".concat(dataTestID, "ModalCancelButton") }, cancelButtonProps, { children: (titles === null || titles === void 0 ? void 0 : titles.cancel) || 'Cancel' }))) : null, onConfirm ? ((0, jsx_runtime_1.jsx)(buttons_1.Button, __assign({ className: buttonClasses, onClick: onConfirm, variant: "primary", "data-testid": "".concat(dataTestID, "ModalConfirmButton") }, confirmButtonProps, { children: (titles === null || titles === void 0 ? void 0 : titles.confirm) || 'Confirm' }))) : null] })));
};
exports.ModalActions = ModalActions;
